import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const LinkedIn = (props) => {
  return (
    <SvgIcon {...props} viewBox='0 0 28 28'>
      <path d='M26 0.5H2C1.1705 0.5 0.5 1.172 0.5 2V26C0.5 26.828 1.1705 27.5 2 27.5H26C26.8295 27.5 27.5 26.828 27.5 26V2C27.5 1.172 26.8295 0.5 26 0.5ZM8.5085 23.5055H4.5005V10.6205H8.5085V23.5055ZM6.5045 8.861C5.2205 8.861 4.1825 7.82 4.1825 6.539C4.1825 5.258 5.219 4.217 6.5045 4.217C7.7855 4.217 8.8265 5.2565 8.8265 6.539C8.8265 7.8215 7.7855 8.861 6.5045 8.861ZM23.507 23.5055H19.5035V17.24C19.5035 15.746 19.4765 13.8245 17.4215 13.8245C15.3365 13.8245 15.02 15.4535 15.02 17.135V23.507H11.0195V10.622H14.8595V12.383H14.915C15.4475 11.3705 16.7555 10.3025 18.701 10.3025C22.757 10.3025 23.5055 12.9695 23.5055 16.4405V23.5055H23.507Z' />
    </SvgIcon>
  );
};

export default LinkedIn;
